var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dropdown-select',{attrs:{"options":_vm.getComputedOptions(),"current-option":_vm.currentOption,"default-option":{ value: 0, name: _vm.__('Wszystkie jednostki') },"icon":"fas fa-users"},on:{"change":_vm.onUnitChange}})}
var staticRenderFns = []

export { render, staticRenderFns }